import theme from '../../../muiTheme';

const styles = {

    tabsContainer: {

        width: '100%',
        height: '60px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        position: 'sticky',
        top: '0px',
        paddingTop: '65px',
        //marginTop: '-1px',
        zIndex: '5',
        
    },
    tabsAvatar: {
        borderRadius: '150px',
        width: '40px', 
        height: '40px',
        marginTop: '0px', 
        marginRight: '20px'   
    },
    swiperContainer: {
        width: '100%',
        //maxWidth: '700px',
        height: 'auto',
        minHeight: '800px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        //border: '2px solid green',
        marginTop: '20px',
        marginBottom: '20px',
        zIndex: '1'
    },
    profileSwiper: {
        width: '100%',

    },
    swiperSlide: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    swiperSlideContentBox: {
        width: '100%',
        height: 'auto',
        maxWidth: '100%',
        //minHeight: '800px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',

    },
    popUpOverlay: {
        width: '100vw',
        height: '100vh',
        // top: '0px',
        // left: '0px',
        // position: 'fixed',
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '0px !important' //not a fan of !important but keeps being overidden by mui5 stack somewhere in their module
    },
    popUpBox: {
        zIndex: 1200,
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#00000094',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    nameSx: {
        fontSize: '14px'
    },
    closeButton: {
        margin: '0px',
        padding: '10px 10px',
        minWidth: '10px',
        maxWidth: '60px',
        marginRight: '5px',
        // border: '0px solid transparent',
        // background: 'transparent',
        //marginLeft: '-30px',
        position: 'absolute',
        right: '15px',
        top: '15px',
        [theme.breakpoints.down('sm')]: {
            position: 'relative',
            border: '0px solid transparent',
            background: 'transparent',
            marginLeft: '-40px',
            marginRight: '20px',
            padding: '15px 15px',
            minWidth: '10px',
            right: 'auto',
            top: '0px',
            //top: '15px',
            //position: 'fixed',
            zIndex: 501,
        }
    }

}

export default styles; 